var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophySolid11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 75,
    viewBox: "0 0 83 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2556_8909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6389 0.5H25.3611C21.5425 0.5 18.43 3.65078 18.5741 7.46641C18.603 8.23242 18.6318 8.99844 18.675 9.75H3.45833C1.54184 9.75 0 11.2965 0 13.2188C0 26.6023 4.82726 35.9102 11.3116 42.2262C17.6951 48.4555 25.4764 51.5918 31.2115 53.1816C34.5833 54.1211 36.8889 56.9395 36.8889 59.7723C36.8889 62.793 34.4392 65.25 31.4276 65.25H27.6667C25.1161 65.25 23.0556 67.3168 23.0556 69.875C23.0556 72.4332 25.1161 74.5 27.6667 74.5H55.3333C57.8839 74.5 59.9444 72.4332 59.9444 69.875C59.9444 67.3168 57.8839 65.25 55.3333 65.25H51.5724C48.5608 65.25 46.1111 62.793 46.1111 59.7723C46.1111 56.9395 48.4023 54.1066 51.7885 53.1816C57.538 51.5918 65.3193 48.4555 71.7028 42.2262C78.1727 35.9102 83 26.6023 83 13.2188C83 11.2965 81.4582 9.75 79.5417 9.75H64.325C64.3682 8.99844 64.3971 8.24688 64.4259 7.46641C64.57 3.65078 61.4575 0.5 57.6389 0.5ZM7.04635 16.6875H19.2082C20.5194 29.7098 23.4158 38.4105 26.6868 44.2352C23.0988 42.6453 19.3667 40.4051 16.1389 37.2543C11.5278 32.7594 7.78125 26.2699 7.06076 16.6875H7.04635ZM66.8755 37.2543C63.6477 40.4051 59.9156 42.6453 56.3276 44.2352C59.5986 38.4105 62.495 29.7098 63.8062 16.6875H75.9681C75.2332 26.2699 71.4866 32.7594 66.8899 37.2543H66.8755Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2556_8909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 74,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophySolid11);
export default __webpack_public_path__ + "static/media/trophy-solid 1 (1).10a89425f6a687b0814101b1172b9dbe.svg";
export { ForwardRef as ReactComponent };